const $ = jQuery;

//files you want to import and combine add here!
console.log('Main.js loaded v1.1');

import '../../node_modules/bootstrap/dist/js/bootstrap.min.js';
import HeaderNavigation from './components/navigation';
import SidebarNav from './components/sidebarNav';
import SvgPropertyMap from './components/map';
// import PropertyList from './components/propertyList';
import Properties from './pages/portfolio';
import NewAcquisition from './components/newAcquisition';
import PropertySingleGmap from './components/propertySingleGmap';
import PropertySpotlight from './components/propertySpotlight';
import Tab from './components/tab';
import Accordion from './components/accordion';
import IntersectionObserverHandler from './components/loadAnimation';
import HeroCarousel from './components/carousel';
import Lenis from 'lenis';
import gsap from '../vendor/js/gsap.min.js';
import ScrollTrigger from '../vendor/js/ScrollTrigger.min.js';
import WhatWeDo from './blocks/what-we-do';
import PartnerSlider from './blocks/partner-slider';
import CardGridWide from './blocks/card-grid-wide';
import Cards2Col from './blocks/cards2Col';
import PinScroller from './blocks/pinScroller';
import LeadersMasonry from './blocks/leaders';
import ESGHighlights from './blocks/esgHighlights';
import SmoothScroll from './components/smoothScroll';
import PropertyAnimations from './components/propertyAnimations';
import FilterAnimations from './components/filterAnimations';
import PageTransitions from './components/pageTransitions';
import SliderLeft from './blocks/sliderLeft';
import StreetMapPopup from './components/streetMapPopup';
class App {
    constructor() {
        // Store component instances
        this.components = {};
        this.controllers = {};
        
        // Initialize when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }

        // Bind cleanup to window unload
        window.addEventListener('unload', () => this.cleanup());
    }

    init() {
        console.log('Initializing App...');
        this.initComponents();
    }

    initComponents() {
        // Initialize page transitions first
        this.components.pageTransitions = new PageTransitions();

        // Initialize smooth scroll first
        this.components.smoothScroll = new SmoothScroll();

        // Initialize navigation with smooth scroll instance
        this.components.navigation = new HeaderNavigation({ 
            smoothScroll: this.components.smoothScroll 
        });

        // Initialize shader if canvas exists
        if (document.getElementById('canvas')) {
            this.components.shader = GradientAnimation.init('canvas');
        }

        // Initialize sidebar navigation if on sidebar template
        if (document.body.classList.contains('page-template-page-sidebar')) {
            this.components.sidebarNav = new SidebarNav();
        }

        // Initialize SVG Property Map if container exists
        if ($('#property-map-container').length) {
            new SvgPropertyMap();
        }

        // Initialize Property List interactions
        if ($('.c-container_property_list').length) {
            this.components.properties = new Properties();
        }

        // Initialize New Acquisition slider if it exists
        this.components.newAcquisition = new NewAcquisition();

        // Initialize property single map if on property single page
        // Note: The class itself now handles the initialization check
        this.components.propertySingleGmap = new PropertySingleGmap();

        // Initialize property spotlight if on property single page
        if ($('#c-img_spotlight_cont').length) {
            this.components.propertySpotlight = new PropertySpotlight();
        }

        // Initialize tabs if tab headers exist
        if (document.querySelector('.c-tab_header')) {
            this.components.tabs = new Tab();
        }

        // Initialize accordion if accordion headers exist
        if (document.querySelector('.c-accordion')) {
            this.components.accordion = new Accordion();
        }

        // Initialize Intersection Observer
        this.components.intersectionObserver = new IntersectionObserverHandler();

        // Initialize carousel if container exists
        if (document.querySelector('.c-carousel_container')) {
            this.components.carousel = new HeroCarousel();
            this.components.carousel.init();
        }

        // Initialize what we do block
        if (document.querySelector('.c-section_what_we_do')) {
            this.components.whatWeDo = new WhatWeDo();
        }

        // Initialize partner slider
        if (document.querySelector('.c-section_partner_slider')) {
            this.components.partnerSlider = new PartnerSlider();
        }

        // Initialize CardGridWide if section exists
        if (document.querySelector('.cc-card_grid_wide')) {
            this.components.cardGridWide = new CardGridWide();
        }

        // Initialize Cards2Col if section exists
        if (document.querySelector('.c-card_2_col.cc-bg_image')) {
            this.components.cards2Col = new Cards2Col();
        }

        // Initialize pin scroller if section exists
        if (document.querySelector('.cc-pin_scroller')) {
            this.components.pinScroller = new PinScroller();
        }

        // Initialize LeadersMasonry if section exists
        if (document.querySelector('.c-leaders_cont')) {
            this.components.leadersMasonry = new LeadersMasonry();
        }

        // Initialize ESGHighlights if section exists
        if (document.querySelector('.c-section.cc-esg_highlights_slider')) {
            this.components.esgHighlights = new ESGHighlights();
        }

        // Initialize property animations
        if (document.querySelector('.c-row_property_list')) {
            new PropertyAnimations();
        }

        // Initialize filter animations
        if (document.querySelector('.c-section_property_filters')) {
            new FilterAnimations();
        }

        // Initialize SliderLeft if section exists
        if (document.querySelector('.c-slider.cc-slider_left')) {
            this.components.sliderLeft = new SliderLeft();
        }

        // Initialize Street Map Popup
        if (document.querySelector('.e-tab_img.cc-street_map')) {
            console.log('Initializing StreetMapPopup');
            this.components.streetMapPopup = new StreetMapPopup();
        }
    }

    cleanup() {
        // Cleanup all components that have a destroy method
        Object.values(this.components).forEach(component => {
            if (component && typeof component.destroy === 'function') {
                component.destroy();
            }
        });

        // Clear the components object
        this.components = {};
    }
}

// Initialize the application
const app = new App();

// Export for potential use elsewhere
export default app;
